export default {"src":"/_next/static/media/actionable.0ad42735.svg","height":50,"width":49,"blurWidth":0,"blurHeight":0};